/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
import { useState, useEffect } from 'react';
import {
  FaPlus, FaTrash, FaPrint, FaSave, FaUtensils, FaUserTie,
} from 'react-icons/fa';
import { FaBangladeshiTakaSign, FaTable } from 'react-icons/fa6';
import PropTypes from 'prop-types';
import { notify } from '../../Shared/toast';
import {
  mockProducts, mockWaiters, mockTables,
} from '../../../data/salesData';
import { saveOrder, sendToKitchen, updateOrder } from '../../../services/orderService';

function SalesEntry({
  initialOrder = null,
  onMockSave = null,
  onMockSendToKitchen = null,
}) {
  const [selectedItem, setSelectedItem] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [quantityType, setQuantityType] = useState('pcs');
  const [sales, setSales] = useState([]);
  // const [customerId, setCustomerId] = useState(mockCustomers[0].id);
  const [tableId, setTableId] = useState('');
  const [waiterId, setWaiterId] = useState('');
  const [orderNotes, setOrderNotes] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);

  // Initialize form if editing an existing order
  useEffect(() => {
    if (initialOrder) {
      setSales(initialOrder.items);
      // setCustomerId(initialOrder.customerId);
      setTableId(initialOrder.tableId);
      setWaiterId(initialOrder.waiterId);
      setOrderNotes(initialOrder.notes || '');
      setIsEditMode(true);
    }
  }, [initialOrder]);

  const handleAddSale = () => {
    const product = mockProducts.find((p) => p.name === selectedItem);
    if (!product || quantity < 1) {
      notify.error('Please select a valid item and quantity');
      return;
    }

    // Check if item already exists in order
    const existingItemIndex = sales.findIndex(
      (item) => item.productId === product.id && item.quantityType === quantityType,
    );

    if (existingItemIndex >= 0) {
      // Update quantity if item exists
      const updatedSales = [...sales];
      updatedSales[existingItemIndex].quantity += quantity;
      updatedSales[existingItemIndex].total = updatedSales[existingItemIndex].price * updatedSales[existingItemIndex].quantity;
      setSales(updatedSales);
    } else {
      // Add new item
      setSales((prev) => [
        ...prev,
        {
          id: Date.now(),
          productId: product.id,
          name: product.name,
          quantity,
          quantityType,
          price: product.price,
          total: product.price * quantity,
          kitchenNotes: product.kitchenNotes || '',
        },
      ]);
    }

    // Reset form
    setSelectedItem('');
    setQuantity(1);
  };

  const removeItem = (id) => {
    setSales((prev) => prev.filter((item) => item.id !== id));
  };

  const calculateTotal = () => sales.reduce((sum, item) => sum + item.total, 0);

  const handleSaveOrder = () => {
    if (sales.length === 0) {
      notify.error('Please add items to the order');
      return;
    }

    if (!tableId) {
      notify.error('Please select a table');
      return;
    }

    if (!waiterId) {
      notify.error('Please select a waiter');
      return;
    }

    // ⬇️ MOCK override
    if (typeof onMockSave === 'function') {
      onMockSave();
      return;
    }

    const orderData = {
      items: sales,
      tableId,
      waiterId,
      total: calculateTotal(),
      notes: orderNotes,
      status: 'draft',
    };

    if (isEditMode) {
      updateOrder(initialOrder.id, orderData);
      notify.success('Order updated successfully!');
    } else {
      saveOrder(orderData);
      notify.success('Order saved successfully!');
    }
  };

  const handleSendToKitchen = () => {
    if (sales.length === 0) {
      notify.error('Please add items to the order');
      return;
    }

    if (!tableId) {
      notify.error('Please select a table');
      return;
    }

    if (!waiterId) {
      notify.error('Please select a waiter');
      return;
    }

    // ⬇️ MOCK override
    if (typeof onMockSendToKitchen === 'function') {
      onMockSendToKitchen();
      return;
    }

    const orderData = {
      items: sales,
      tableId,
      waiterId,
      total: calculateTotal(),
      notes: orderNotes,
      status: 'in-progress',
    };

    if (isEditMode) {
      const updatedOrder = updateOrder(initialOrder.id, orderData);
      sendToKitchen(updatedOrder.id);
      notify.success('Order updated and sent to kitchen!');
    } else {
      const newOrder = saveOrder(orderData);
      sendToKitchen(newOrder.id);
      notify.success('Order sent to kitchen!');
    }

    if (!isEditMode) {
      setSales([]);
      setTableId('');
      setOrderNotes('');
    }
  };

  // const selectedCustomer = mockCustomers.find((c) => c.id === customerId) || mockCustomers[0];
  const selectedTable = mockTables.find((t) => t.id === tableId);
  const selectedWaiter = mockWaiters.find((w) => w.id === waiterId);

  return (
    <div className="max-w-4xl mx-auto p-6 bg-gray-50 min-h-screen">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">
        {isEditMode ? 'Update Order' : 'New Sale Entry'}
      </h2>

      <div className="bg-white rounded-xl shadow-md p-6 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          {/* <div>
            <label htmlFor="customer-select" className="block text-sm font-medium text-gray-700 mb-1">
              Customer
            </label>
            <select
              id="customer-select"
              value={customerId}
              onChange={(e) => setCustomerId(Number(e.target.value))}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
            >
              {mockCustomers.map((customer) => (
                <option key={customer.id} value={customer.id}>
                  {customer.name}
                  {' '}
                  {customer.phone ? `(${customer.phone})` : ''}
                </option>
              ))}
            </select>
          </div> */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Customer Phone:
              {' '}
              {selectedCustomer.phone || 'Not provided'}
            </label>
            <div className="mt-1 text-sm text-gray-500">
              Loyalty Points:
              {' '}
              {selectedCustomer.loyaltyPoints || 0}
            </div>
          </div> */}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div>
            <label htmlFor="table-select" className="block text-sm font-medium text-gray-700 mb-1">
              Table
              {' '}
              <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <select
                id="table-select"
                value={String(tableId)}
                onChange={(e) => setTableId(Number(e.target.value))}
                className="w-full border border-gray-300 rounded-lg px-4 py-2 pl-10 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
              >
                <option value="">Select a table</option>
                {mockTables.map((table) => (
                  <option key={table.id} value={String(table.id)}>
                    {table.id}
                    {' '}
                    (
                    {table.capacity}
                    {' '}
                    persons) -
                    {table.status}
                  </option>
                ))}
              </select>

              <FaTable className="absolute left-3 top-3 text-gray-400" />
            </div>
          </div>

          <div>
            <label htmlFor="waiter-select" className="block text-sm font-medium text-gray-700 mb-1">
              Waiter
              {' '}
              <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <select
                id="waiter-select"
                value={waiterId}
                onChange={(e) => setWaiterId(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-4 py-2 pl-10 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
              >
                <option value="">Select a waiter</option>
                {mockWaiters.map((waiter) => (
                  <option key={waiter.id} value={waiter.id}>
                    {waiter.name}
                    {' '}
                    (
                    {waiter.code}
                    )
                  </option>
                ))}
              </select>
              <FaUserTie className="absolute left-3 top-3 text-gray-400" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div>
            <label htmlFor="menu-item" className="block text-sm font-medium text-gray-700 mb-1">
              Menu Item
            </label>
            <select
              id="menu-item"
              value={selectedItem}
              onChange={(e) => setSelectedItem(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
            >
              <option value="">Select an item</option>
              {mockProducts.map((product) => (
                <option key={product.id} value={product.name}>
                  {product.name}
                  {' '}
                  - ৳
                  {product.price}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="quantity" className="block text-sm font-medium text-gray-700 mb-1">
              Quantity
            </label>
            <div className="flex">
              <input
                id="quantity"
                type="number"
                min="1"
                value={quantity}
                onChange={(e) => setQuantity(Math.max(1, parseInt(e.target.value, 10) || 1))}
                className="w-full border border-gray-300 rounded-l-lg px-4 py-2 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
              />
              <select
                value={quantityType}
                onChange={(e) => setQuantityType(e.target.value)}
                className="border border-gray-300 border-l-0 rounded-r-lg px-2 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
              >
                <option value="pcs">Pcs</option>
                <option value="plates">Plates</option>
                <option value="glasses">Glasses</option>
                <option value="boxes">Boxes</option>
              </select>
            </div>
          </div>

          <div className="flex items-end">
            <button
              type="button"
              onClick={handleAddSale}
              className="w-full bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg flex items-center justify-center transition-colors"
            >
              <FaPlus className="mr-2" />
              Add Item
            </button>
          </div>
        </div>

        <div className="mt-4">
          <label htmlFor="order-notes" className="block text-sm font-medium text-gray-700 mb-1">
            Order Notes
          </label>
          <textarea
            id="order-notes"
            value={orderNotes}
            onChange={(e) => setOrderNotes(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring-2 focus:ring-red-500 focus:border-red-500 outline-none transition"
            rows="2"
            placeholder="Special instructions for kitchen..."
          />
        </div>
      </div>

      {/* Order Summary */}
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="px-6 py-4 border-b">
          <h3 className="text-lg font-semibold text-gray-800">Order Summary</h3>
        </div>

        {sales.length > 0 ? (
          <>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Item</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Qty</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {sales.map((sale) => (
                    <tr key={sale.id}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{sale.name}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 flex items-center">
                        <FaBangladeshiTakaSign className="mr-1" />
                        {sale.price}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {sale.quantity}
                        {' '}
                        {sale.quantityType}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium flex items-center">
                        <FaBangladeshiTakaSign className="mr-1" />
                        {sale.total}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        <button
                          type="button"
                          onClick={() => removeItem(sale.id)}
                          className="text-red-600 hover:text-red-800"
                          aria-label={`Remove ${sale.name}`}
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="px-6 py-4 border-t bg-gray-50">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  {/* <div className="mb-2">
                    <p className="text-sm font-medium text-gray-700">
                      <span className="inline-block w-24">Customer:</span>
                      <span className="font-normal">{selectedCustomer.name}</span>
                    </p>
                    {selectedCustomer.phone && (
                      <p className="text-sm font-medium text-gray-700">
                        <span className="inline-block w-24">Phone:</span>
                        <span className="font-normal">{selectedCustomer.phone}</span>
                      </p>
                    )}
                  </div> */}
                  {selectedTable && (
                    <div className="mb-2">
                      <p className="text-sm font-medium text-gray-700">
                        <span className="inline-block w-24">Table:</span>
                        <span className="font-normal">
                          {selectedTable.name}
                          {' '}
                          (
                          {selectedTable.capacity}
                          {' '}
                          persons)
                        </span>
                      </p>
                    </div>
                  )}
                  {selectedWaiter && (
                    <div>
                      <p className="text-sm font-medium text-gray-700">
                        <span className="inline-block w-24">Waiter:</span>
                        <span className="font-normal">{selectedWaiter.name}</span>
                      </p>
                    </div>
                  )}
                </div>

                <div className="text-right">
                  <p className="text-lg font-bold text-gray-800 flex items-center justify-end">
                    <span className="mr-2">Total:</span>
                    <FaBangladeshiTakaSign className="mr-1" />
                    {calculateTotal().toLocaleString()}
                  </p>
                  <div className="flex space-x-3 mt-4 justify-end">
                    <button
                      type="button"
                      className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg flex items-center transition-colors"
                      onClick={() => window.print()}
                    >
                      <FaPrint className="mr-2" />
                      Print
                    </button>
                    <button
                      type="button"
                      className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center transition-colors"
                      onClick={handleSaveOrder}
                    >
                      <FaSave className="mr-2" />
                      {isEditMode ? 'Update' : 'Save'}
                      {' '}
                      Order
                    </button>
                    <button
                      type="button"
                      className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center transition-colors"
                      onClick={handleSendToKitchen}
                    >
                      <FaUtensils className="mr-2" />
                      Send to Kitchen
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="p-6 text-center text-gray-500">
            No items added to the order yet. Please add items from above.
          </div>
        )}
      </div>
    </div>
  );
}
SalesEntry.propTypes = {
  initialOrder: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    items: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      quantity: PropTypes.number,
      quantityType: PropTypes.string,
      price: PropTypes.number,
      total: PropTypes.number,
      kitchenNotes: PropTypes.string,
    })),
    customerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tableId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    waiterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    notes: PropTypes.string,
  }),
  onMockSave: PropTypes.func,
  onMockSendToKitchen: PropTypes.func,
};

SalesEntry.defaultProps = {
  initialOrder: null,
  onMockSave: null,
  onMockSendToKitchen: null,
};

export default SalesEntry;
